var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKillsMob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97975 15.816C8.53627 15.816 8.10272 15.7729 7.68262 15.6917L6.6543 16.4352C7.38898 16.6655 8.17009 16.7898 8.97975 16.7898C9.79963 16.7898 10.5901 16.6621 11.3329 16.4261L10.3086 15.6855C9.87862 15.7709 9.43436 15.816 8.97975 15.816Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33884 2.38362L7.68798 1.31738C5.01984 1.76469 2.80722 3.57248 1.79053 6.00102L2.86102 5.99859C3.73841 4.21697 5.37117 2.87182 7.33884 2.38362Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21102 9.79947L1.19092 9.05469C1.20528 11.1518 2.05255 13.0545 3.41784 14.4481L3.76199 13.3804C2.92708 12.3873 2.36986 11.1534 2.21102 9.79947Z",
    fill: "#808080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7453 9.83114C15.5834 11.1571 15.0394 12.3665 14.2271 13.3458L14.5724 14.417C15.9135 13.0328 16.7468 11.154 16.7688 9.08398L15.7453 9.83114Z",
    fill: "#808080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0988 5.99916L16.1693 6.00165C15.158 3.58601 12.9635 1.78437 10.3145 1.3252L10.6648 2.39496C12.6129 2.89211 14.2279 4.23074 15.0988 5.99916Z",
    fill: "#808080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5623 17.5596L12.4563 11.0268L18 6.97933L11.1361 6.96363L9 0.44043L6.86394 6.96363L0 6.97933L5.54363 11.0268L3.43751 17.5596L9 13.5378L14.5623 17.5596Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKillsMob);
export default __webpack_public_path__ + "static/media/killsMob.370b4d4e9adad8769d1272da6c226ffc.svg";
export { ForwardRef as ReactComponent };